import { priceInfoDTO } from './priceInfoDTO';

import type { OrderPriceInfo } from './types';

export const priceInfoOrDefaultDTO = (data: unknown): OrderPriceInfo[] => {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  return priceInfoDTO(data);
};
